import CurveSettings from "@/curve/CurveSettings";

export default [
    {
        path: '/curveSettings',
        component: CurveSettings
    },
];
